// extracted by mini-css-extract-plugin
module.exports = {"complex":"ComplexInputs_complex__3zj0A","two-inline":"ComplexInputs_two-inline__3cpQw"};